export enum SyncFeedbackRating {
  NoRating = '',
  Rating1 = '1',
  Rating2 = '2',
  Rating3 = '3',
  Rating4 = '4',
  Rating5 = '5',
}
